interface AcknowledgmentsInterface {
    DateOnApplicationAcknowledgement: string,
    SubDaysOnApplicationAcknowledgement: string,
    SubDaysOnReimbursementAcknowledgement: string,
    CarAllowanceOnReimbursementAcknowledgement: string,
    TransportationOnReimbursementAcknowledgement: string,
    AccommodationExpensesOnReimbursementAcknowledgement: string,
    SubsistenceOnReimbursementAcknowledgement: string,
    SubmitOnReimbursementAcknowledgement: string,
    TransportationOnApplicationAcknowledgement: string,
    AccommodationExpensesOnApplicationAcknowledgement: string
}

export const Acknowledgments: AcknowledgmentsInterface = {
    DateOnApplicationAcknowledgement: "DateOnApplicationAcknowledgement",
    SubDaysOnApplicationAcknowledgement: "SubDaysOnApplicationAcknowledgement",
    SubDaysOnReimbursementAcknowledgement: "SubDaysOnReimbursementAcknowledgement",
    CarAllowanceOnReimbursementAcknowledgement: "CarAllowanceOnReimbursementAcknowledgement",
    TransportationOnApplicationAcknowledgement: "TransportationOnApplicationAcknowledgement",
    TransportationOnReimbursementAcknowledgement: "TransportationOnReimbursementAcknowledgement",
    AccommodationExpensesOnApplicationAcknowledgement: "AccommodationExpensesOnApplicationAcknowledgement",
    AccommodationExpensesOnReimbursementAcknowledgement: "AccommodationExpensesOnReimbursementAcknowledgement",
    SubsistenceOnReimbursementAcknowledgement: "SubsistenceOnReimbursementAcknowledgement",
    SubmitOnReimbursementAcknowledgement: "SubmitOnReimbursementAcknowledgement",
}
